exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/departament/departament.component.css
// module id = ../../../../../src/app/departament/departament.component.css
// module chunks = main